
import { Delegate, DelegatesWithPagination } from "@/api/types";
import { Companies } from "@/api";
import Spinner from "@/components/shared/Spinner.vue";
import { Component, ModelSync, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import TitleHeader from "../common/TitleHeader.vue";

const SDelegate = namespace("delegate");
const SEvents = namespace("events");
@Component({
  components: { Spinner, TitleHeader }
})
export default class DelegatesList extends Vue {
  delegates: Array<Delegate> = [];
  filters = {
    company: null,
    name: "",
    id: "",
    active: 1
  };
  options: any = {};
  page = 1;
  limit = 10;
  headers = [
    {
      text: "Company",
      value: "company"
    },
    {
      text: "Delegate",
      value: "name"
    },
    {
      text: "Passport / ID",
      value: "passport"
    },
    {
      text: "Phone number",
      value: "cell_phone"
    },
    {
      text: "Actions",
      value: "controls",
      sortable: false,
      width: "50px"
    }
  ];
  loading = false;
  bookingCompanies: any[] = [];
  requestId = 0;

  //ACTIONS

  @SDelegate.Action("getListDelegates")
  public getListDelegates!: (params: {
    page: number;
    filters: object;
    limit: number;
    withDeleted?: boolean;
  }) => Promise<any>;

  //STATE

  @SDelegate.State("delegatesWithPagination")
  delegatesWithPagination: any;
  @SDelegate.State("delegatesArray") delegatesArray: any;
  @SEvents.State("event") event: any;
  @SEvents.State("coursesInfo") coursesInfo: any;
  currentDelegatesWithPagination: DelegatesWithPagination = {
    meta: { perPage: this.limit }
  };

  @ModelSync("selected", "changegetListDelegates", { type: Array })
  selectedValue!: any;

  get perPage() {
    return this.currentDelegatesWithPagination?.meta?.perPage || 0;
  }
  get total() {
    return this.currentDelegatesWithPagination?.meta?.total || 0;
  }

  async created() {
    await this.getCompanies();
    await this.loadDelegatesData();
  }

  get bookingCompanyIds(): string {
    return (this.event.company || [])
      .map((company: any) => company.companyId)
      .filter(Boolean)
      .sort()
      .join(",");
  }

  async getCompanies() {
    try {
      const companyIds = this.bookingCompanyIds;
      const companies = await Companies.bookingOptions(companyIds);
      if (companyIds === this.bookingCompanyIds)
        this.bookingCompanies = companies;
    } catch (e) {
      await this.$error(e);
    }
  }

  async loadDelegatesData(
    page = 1,
    filters: {
      company: string | null;
      name: string;
      id: string;
      active?: number;
    } = this.filters
  ) {
    const requestId = ++this.requestId;
    try {
      this.loading = true;
      await this.getListDelegates({
        page: page,
        filters: { ...filters, bookingCompanyIds: this.bookingCompanyIds },
        limit: this.limit,
        withDeleted: false
      });
      if (requestId !== this.requestId) return;
      this.currentDelegatesWithPagination = {
        ...this.delegatesWithPagination
      };
      this.delegates = this.currentDelegatesWithPagination?.data || [];
    } catch (e) {
      await this.$error(e);
    }
    if (requestId === this.requestId) this.loading = false;
  }
  isActive(id: number) {
    return !!this.selectedValue.find(
      (el: { id: number; companyId: number | string }) => el.id == id
    );
  }

  onAssign(delegate: any) {
    const id = delegate.id;
    const companyId = delegate.company.id;
    const itemIndex = this.selectedValue.findIndex(
      (el: { id: number; companyId: number | string }) => el.id == id
    );
    if (itemIndex === -1) {
      this.selectedValue.push({ id, companyId });
      if (
        Number(delegate.company.type) === 2 &&
        !this.event.company.some(
          (company: any) => String(company.companyId) === String(companyId)
        )
      ) {
        this.event.company = [
          ...this.event.company.filter((company: any) => company.companyId),
          { companyId, isPrivate: true, price: this.coursesInfo?.price ?? 0 }
        ];
      }
    } else {
      this.selectedValue.splice(itemIndex, 1);
      if (
        Number(delegate.company.type) === 2 &&
        !this.selectedValue.some((item: any) => item.companyId === companyId)
      ) {
        this.event.company = this.event.company.filter(
          (company: any) =>
            String(company.companyId) !== String(companyId) ||
            !company.isPrivate
        );
      }
    }
  }

  // @Watch("filters", { deep: true })
  async onChangeFilters() {
    this.page = 1;
    this.options.page = 1;
    await this.loadDelegatesData(1, this.filters);
  }

  @Watch("options", { deep: true })
  async onChangePage(val: any) {
    this.limit = val.itemsPerPage;
    if (this.limit === -1) this.limit = 9999;
    await this.loadDelegatesData(val.page, this.filters);
  }

  @Watch("bookingCompanyIds")
  async updEventCompanies() {
    const companyIds = new Set(this.bookingCompanyIds.split(","));
    this.selectedValue = this.selectedValue.filter((delegate: any) =>
      companyIds.has(String(delegate.companyId))
    );
    this.filters.company = null;
    this.page = 1;
    this.options.page = 1;
    await this.getCompanies();
    await this.loadDelegatesData(1, this.filters);
  }
}
